<template>
    <div class="table-responsive">
        <table class="table table-bordered table-sm table-hover mb-0">
            <colgroup>
                <col style="width: 8%;" />
                <col style="width: 22%;" />
                <col style="width: 22%;" />
                <col style="width: 24%;" />
                <col style="width: 24%;" />
            </colgroup>
            <thead class="thead-light">
                <tr>
                    <th class="text-center">{{ "보정" }}</th>
                    <th class="text-center">{{ "시간" }}</th>
                    <th class="text-center">{{ "집계값" }}</th>
                    <th class="text-center">{{ "원본값" }}</th>
                    <th class="text-center">{{ "이전값" }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(data, idx) in tableData" :key="data.regDt" :style="{ backgroundColor: rowColorClass(idx) }">
                    <td>
                        <!-- <div
                            class="checkbox checkbox-css d-flex justify-content-center"
                            style="padding: 0px !important"
                        >
                            <input
                                type="checkbox"
                                :id="`isCorrect-${idx}`"
                                :checked="data.isCorrected == 'Y' ? true : false"
                                disabled
                            />
                            <label :for="`isCorrect-${idx}`"></label>
                        </div> -->
                        <span
                            v-if="data.isCorrected == 'Y'"
                            style="display: flex; justify-content: center; align-items: center; color: red;"
                        >
                            <i class="fa fa-check" aria-hidden="true"></i>
                        </span>
                    </td>
                    <td class="text-center">{{ data.regDt ? data.regDt : "-" }}</td>
                    <td class="text-right">{{ data.ptVal !== null ? data.ptVal.toFixed(1) : "-" }}</td>
                    <td class="text-right">{{ data.ptOrg !== null ? data.ptOrg.toFixed(1) : "-" }}</td>
                    <td class="text-right">{{ data.ptPre !== null ? data.ptPre.toFixed(1) : "-" }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from "moment";
import excelHelper from "@src/libs/excelHelper.js";

export default {
    props: {
        totalLog: { type: Array, default: () => [] },
        flagRawDownload: { type: Boolean, default: false },
        tableRowColor: { type: Array, default: () => [] },
    },
    components: {},
    data() {
        return {};
    },
    watch: {
        flagRawDownload(val) {
            if (val) {
                this.exportToExcel();
            }
        },
    },
    computed: {
        tableData() {
            return this.totalLog.map((item) => ({
                ...item,
                regDt: moment(item.regDt.toString(), "YYYYMMDDHHmmss").format("HH:mm:ss"),
            }));
        },
    },
    created() {},
    mounted() {},
    methods: {
        async exportToExcel() {
            try {
                // 헤더 정의
                const headers = ["보정", "시간", "집계값", "원본값", "이전값"];

                // 데이터 변환 (excelHelper 형식에 맞게)
                const excelData = this.tableData.map((item) => ({
                    보정: item.isCorrected === "Y" ? "✓" : "",
                    시간: item.regDt || "-",
                    집계값: item.ptVal !== null ? item.ptVal.toFixed(1) : "-",
                    원본값: item.ptOrg !== null ? item.ptOrg.toFixed(1) : "-",
                    이전값: item.ptPre !== null ? item.ptPre.toFixed(1) : "-",
                }));

                // 파일명 생성 (현재 날짜 포함)
                const currentDate = new Date().toISOString().slice(0, 10);
                const fileName = `원시데이터_${currentDate}.xlsx`;

                // excelHelper를 사용하여 워크북 생성 및 다운로드
                await excelHelper.createAndDownloadWorkbook(excelData, headers, fileName, {
                    sheetName: "원시데이터", // 시트명 지정
                    creator: "THEKIE",
                    lastModifiedBy: "THEKIE",
                    columnWidths: {
                        보정: 8,
                        시간: 12,
                        집계값: 15,
                        원본값: 15,
                        이전값: 15,
                    },
                    // 셀 타입 지정
                    cellTypes: {
                        보정: "string", // 텍스트
                        시간: "string", // 텍스트
                        집계값: "number", // 숫자
                        원본값: "number", // 숫자
                        이전값: "number", // 숫자
                    },
                });

                this.$emit("download-finished");
            } catch (error) {
                console.error("엑셀 다운로드 중 오류 발생:", error);
                this.$emit("download-error", error.message);
            }
        },
        rowColorClass(idx) {
            const colorIdx = Math.floor(idx / 3) % this.tableRowColor.length;
            return this.tableRowColor[colorIdx];
        },
    },
};
</script>

<style scoped>
.table-responsive {
    height: 68vh;
    overflow-y: auto;
    position: relative;
}

table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
    table-layout: fixed;
}

thead {
    display: table-header-group;
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 2;
}
tbody {
    display: table-row-group;
}
.table thead th,
.table tbody td {
    font-size: 13px;
    box-sizing: border-box;

    font-weight: 600;
}
.table thead th {
    font-weight: 600;
}
.table tbody td {
    font-weight: 400;
}
</style>
